import script from "./floatWindow.vue?vue&type=script&setup=true&lang=js"
export * from "./floatWindow.vue?vue&type=script&setup=true&lang=js"

import "./floatWindow.vue?vue&type=style&index=0&id=3108b8f8&lang=scss&scoped=true"

import exportComponent from "/var/www/ddup_czb/slczb_app_web/view/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3108b8f8"]])

export default __exports__